/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInstrumentLinksByInstrumentTokenRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetInstrumentLinksByInstrumentToken.pb'
import {GetInstrumentLinksByInstrumentTokenResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetInstrumentLinksByInstrumentToken.pb'


export const getInstrumentLinksByInstrumentToken = (request:GetInstrumentLinksByInstrumentTokenRequest, options?: CashRequestOptions) => post<GetInstrumentLinksByInstrumentTokenRequest, GetInstrumentLinksByInstrumentTokenResponse>("/2.0/cash/get-instrument-links-by-instrument-token", request, {...options, rejectOnError: true })